export function getFontData (styles) {
  const styleIds = Object.keys(styles);
  const groupedFonts = {};

  styleIds.forEach(id => {
    const style = styles[id];
    if (style) {
      const fontFamily = style.font_family;
      const fontWeight = style.font_weight;

      if (!groupedFonts[fontFamily] && fontFamily) {
        groupedFonts[fontFamily] = {
          variations: new Set(),
          customFontId: style.custom_font_id
        };
      }

      if (fontFamily && fontWeight) { groupedFonts[fontFamily].variations.add(fontWeight); }
    }
  });

  for (const fontFamily in groupedFonts) {
    groupedFonts[fontFamily].variations = Array.from(groupedFonts[fontFamily].variations);
  }

  return groupedFonts;
}

export function formatStyle (styleId, styles) {
  const style = styles[styleId];
  if (!style) return null;

  return {
    id: Number(style.id || styleId),
    name: style.name,
    fill: style.fill,
    fontFamily: style.font_family,
    fontWeight: style.font_weight,
    fontStyle: style.font_style,
    customFontId: style.custom_font_id,
    fontStretch: style.font_stretch
  };
}

export function formatMetadata ({ styles, folders }) {
  const filteredFolders = folders.reduce((acc, folder) => {
    const { id, name, style_ids: styleIds } = folder;
    const folderStyles = styleIds.reduce((stylesAcc, styleId) => {
      const formattedStyle = formatStyle(styleId, styles);
      if (formattedStyle) {
        return stylesAcc.concat(formattedStyle);
      }
      return stylesAcc;
    }, []);

    if (folderStyles.length === 0) return acc;

    return [
      ...acc,
      {
        id,
        name,
        styles: folderStyles
      }
    ];
  }, []);
  const fonts = getFontData(styles);

  return {
    folders: filteredFolders,
    styles,
    fonts
  };
}
